import { useRef } from "react";
import React from 'react';
import Typed from "typed.js";

const TypingAnimation = () => {
  // Create Ref element.
  const el = useRef(null);

  React.useEffect(() => {
    const typed = new Typed(el.current, {
      strings: ["Desarrollador FullStack","Instructor de Fitness", "Entrenador Personal"], // Strings to display
      typeSpeed: 70,
      backSpeed: 70,
      backDelay: 100,
      smartBackspace: true,
      loop: true,
      showCursor: true,
    });

    // Destropying
    return () => {
      typed.destroy();
    };
  }, []);
  return (
     <span ref={el}></span>
  );
};
export default TypingAnimation;
